// Generated by ReScript, PLEASE EDIT WITH CARE


var successResponse = {
    status_code: 200,
    status: "Successful message"
  };

export {
  successResponse ,
  
}
/* No side effect */
